var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('b-modal', {
    attrs: {
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "xl",
      "id": "modal-asset",
      "title": "Daftar Aset"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "disabled": !_vm.thereSelectedAsset,
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.submit($event);
            }
          }
        }, [_vm._v("Pilih Aset")])];
      },
      proxy: true
    }])
  }, [_c('b-table', {
    staticClass: "mb-2",
    attrs: {
      "responsive": "",
      "bordered": "",
      "fields": _vm.fields,
      "items": _vm.localAssets
    },
    scopedSlots: _vm._u([{
      key: "head(checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          model: {
            value: _vm.allChecked,
            callback: function callback($$v) {
              _vm.allChecked = $$v;
            },
            expression: "allChecked"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [parseInt(item.stok) > 0 ? _c('b-form-checkbox', {
          attrs: {
            "value": item
          },
          model: {
            value: _vm.selectedAssets,
            callback: function callback($$v) {
              _vm.selectedAssets = $$v;
            },
            expression: "selectedAssets"
          }
        }) : _c('feather-icon', {
          staticClass: "text-danger",
          attrs: {
            "icon": "XIcon"
          }
        })];
      }
    }, {
      key: "cell(nama)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.asset.nama) + " ")];
      }
    }, {
      key: "cell(kode)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(item.asset.kode) + " ")];
      }
    }, {
      key: "cell(satuan)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm._v(" " + _vm._s(item.asset.satuan ? item.asset.satuan.satuan : '') + " ")];
      }
    }, {
      key: "cell(harga_dasar)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" Rp " + _vm._s(_vm.formatRupiah(item.asset.harga_dasar)) + " ")];
      }
    }, {
      key: "cell(jumlah)",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [parseInt(item.stok) > 0 ? _c('b-form-input', {
          model: {
            value: item.jumlah,
            callback: function callback($$v) {
              _vm.$set(item, "jumlah", $$v);
            },
            expression: "item.jumlah"
          }
        }) : _c('i', {
          staticClass: "text-danger"
        }, [_c('small', [_vm._v("Stok Aset 0")])])];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }